// material-ui

import boxedtruck18ton3axles from '../../../assets/images/Truck/boxed-truck-18-ton-3-axles.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const BoxedTruck18Ton3Axles = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={boxedtruck18ton3axles} alt="Boxed truck 18 ton 3 axles " height={props.height || 30}  />
    );
};

export default BoxedTruck18Ton3Axles;